import React, { useEffect, useState } from 'react';
import bell from '../../../assets/dashboard/bell.png';
import bg from '../../../assets/dashboard/bg.jpg';
import blue from '../../../assets/dashboard/blue.png';
import coursecard from '../../../assets/dashboard/coursecard.svg';
import dot from '../../../assets/dashboard/dot.png';
import trainerhatIcon from '../../../assets/dashboard/trainer-hat-icon.png';
import totalCoursesIcon from '../../../assets/dashboard/totalcourses-icon.png';
import userIcon from '../../../assets/dashboard/user-icon.png';

import dummyImage from '../../../assets/dashboard/DummyImage.jpg';
import green from '../../../assets/dashboard/green.png';
import percentage from '../../../assets/dashboard/percentage.png';
import rates from '../../../assets/dashboard/rates.png';
import soldProducts from '../../../assets/dashboard/soldproducts.png';
import userImage from '../../../assets/dashboard/userimage.png';
import newsImg from '../../../assets/dashboard/news.png';
import groupRight from '../../../assets/dashboard/green.png';
import certIcon from '../../../assets/dashboard/coursecard.svg';

import DashboardCharts from './DashboardCharts';
import { getMyDashboardData } from '../../../services/Admin/admin';
import './dashboard.css'
import PaginatedNotifications from './PaginatedNotifications';


const AdminDashboard = () => {

  const [dashboardData, setDashboardData] = useState();
  const [loading , setLoading] = useState(false)
  const fetchData = async () => {
    setLoading(true)
    const data = await getMyDashboardData();
    if (data) {
      console.log("admin profile data >>>", data);
      setDashboardData(data);
    }
    setLoading(false)
  };

  useEffect(() => {
    fetchData();
  }, []);


  return (
    <div className="col-md-12 main_area dashboard-main-container">
      {/* <div className="row profile_row">
        <div className="col-md-6">
          <h2 className="title_main">Dashboard</h2>
        </div>
        <div className="col-md-6">
          <div className="icon_profile text-end">
            <img src={bell} className="notification_icon" alt="bell" />
            <img src={userImage} className="profile_picture" alt="profile" />
          </div>
        </div>
      </div> */}

      {
        loading ?
         <div className="col-md-12" style={{ height: '40vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <div class="spinner-border spinner-border-sm" role="status"></div>
          </div>
          :
          <>
          <div className="row four_colums info-card-container">
        <div className="col-md-3">
          <div className="image_box">
            <div className="content_box">
              <div className="dot_title">
                <img src={dot} alt="dot" className="dot" />
                <p className='ps-2'>Total Courses</p>
              </div>
              <h4 className="mt-2">{dashboardData?.totalCourses}</h4>
            </div>
            <div className="img_icon">
              <img src={totalCoursesIcon} alt="sold products" />
            </div>
          </div>
        </div>
        <div className="col-md-3 info-card-container">
          <div className="image_box">
            <div className="content_box">
              <div className="dot_title">
                <img src={green} alt="dot" className="dot" />
                <p className='ps-2'>Total Staff</p>
              </div>
              <h4 className="mt-2">{dashboardData?.totalStaff}</h4>
            </div>
            <div className="img_icon">
              <img src={userIcon} alt="rates" />
            </div>
          </div>
        </div>
        <div className="col-md-3 info-card-container">
          <div className="image_box">
            <div className="content_box">
              <div className="dot_title">
                <img src={blue} alt="dot" className="dot" />
                <p className='ps-2'>Total Managers</p>
              </div>
              <h4 className="mt-2">{dashboardData?.totalTrainers}</h4>
            </div>
            <div className="img_icon">
              <img src={trainerhatIcon} alt="percentage" />
            </div>
          </div>
        </div>
        {/* <div className="col-md-3">
          <div className="image_box">
            <div className="content_box">
              <h2 className="mt-2">Fresha</h2>
            </div>
          </div>
        </div> */}
      </div>

      <div className="Graph_section py-5 text-center">
        <DashboardCharts userData={dashboardData} />
        {/* <img src={dummyImage} className="img-fluid" alt="graph" /> */}
      </div>
    
      <div className="dashboard-notification py-5 ">
          <h3 className="chart-title mb-4" style={{color:'#72675B', fontWeight:'700'}}>Notifications</h3>

        {/* {dashboardData?.notifications.length > 0 && dashboardData?.notifications.map((item) => {
          // Helper function to get notification icon based on message type
          const getNotificationIcon = (message) => {
            if (message.includes('reacted') || message.includes('liked')) {
              return (
                <div className="notification-icon like-icon">
                  <i className="bi bi-hand-thumbs-up-fill"></i>
                </div>
              );
            } else if (message.includes('completed') || message.includes('updated')) {
              return (
                <div className="notification-icon completed-icon">
                  <i className="bi bi-check-circle-fill"></i>
                </div>
              );
            } else {
              return (
                <div className="notification-icon default-icon">
                  <i className="bi bi-bell-fill"></i>
                </div>
              );
            }
          };

          // Helper function to format time
          const formatTime = (dateString) => {
            const date = new Date(dateString);
            return date.toLocaleTimeString('en-US', {
              hour: '2-digit',
              minute: '2-digit',
              hour12: true
            });
          };

          // Helper function to format date
          const formatDate = (dateString) => {
            const date = new Date(dateString);
            return date.toLocaleDateString('en-GB', {
              day: '2-digit',
              month: '2-digit',
              year: 'numeric'
            });
          };

          return (
            <div key={item._id} className="notification-item mb-4">
              <div className="notification-content">
                <div className="notification-left">
                  {getNotificationIcon(item.message)}
                  <div className="notification-details">
                    <div className="notification-header">
                      <span className="notification-time">
                        {formatTime(item.createdAt)}
                      </span>
                      <span className="online-indicator"></span>
                    </div>
                    <div className="notification-text">
                      <span className="user-name" style={{ paddingRight: '5px' }}>{item.user?.fullName || 'Unknown'}</span>
                      <span className="notification-action">
                        {item.message.replace(item.user?.fullName, '').trim()}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="notification-date">
                  {formatDate(item.createdAt)}
                </div>
              </div>
            </div>
          );
        })} */}
         <PaginatedNotifications />
      </div>
          </>
      }

      

    </div>
  );
};

export default AdminDashboard;
